export default "__VITE_ASSET__Cw663n0B__"